import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from '@/router'
import { AsrRtModule } from '@/store/modules/asr-rt'
import {
  provide,
  shallowRef,
} from 'vue'
import SimpleUploader from '@/components/SimpleUploader/index.vue'
import { UPLOAD_SUCCESS_CBS, UPLOAD_FILE_EVT, EnumImportType } from '@/components/SimpleUploader/type'
import { SimpleUploaderModule } from '@/store/modules/simple-uploader'
import { StorageDaysModule } from '@/store/modules/storage-days'
import {  getRetentionDays } from '@/api/user/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'AppMain',
  setup(__props) {

const route = useRoute()
// 判断是否需要弹窗提示
window.onbeforeunload = function () {
  const needAsrRTAlert = AsrRtModule.needAlert
  const needSimpleUploaderAlert = SimpleUploaderModule.isFileUploading
  if(needAsrRTAlert || needSimpleUploaderAlert) {
    return true
  }
}

const uploadFileRef = shallowRef<InstanceType<typeof SimpleUploader>>()
const uploadSuccessCbs: Array<(...args: any) => any> = []
provide(UPLOAD_SUCCESS_CBS, uploadSuccessCbs)
function handleUploadSuccess (...args: any) {
  uploadSuccessCbs.forEach(cb => {
    try {
      cb(...args)
    } catch (e) {
      console.error('执行上传回调事件数组抛异常:', e)
    }
  })
}
provide(UPLOAD_FILE_EVT, handleUpdateFile)
function handleUpdateFile (type: EnumImportType) {
  switch (type) {
    case EnumImportType.FILE:
          uploadFileRef.value?.handleUploadBtnClick()
      break
    case EnumImportType.DRAG:
      if (uploadFileRef.value) {
        uploadFileRef.value.dropBoxShow = true
      }
      break
    default:
      break
  }
}
async function getStorageDays() {
  try {
    let res = await getRetentionDays()
    let days = res.data
    StorageDaysModule.SetStorageDays(days)
  } catch (error) {
    error
  }
}
getStorageDays()

return { __sfc: true,route, uploadFileRef, uploadSuccessCbs, handleUploadSuccess, handleUpdateFile, getStorageDays, SimpleUploader }
}

})